module.exports = __webpack_public_path__ + "static/media/benefits3.3f9218d1.png";